VueGlobal.directive('number-only', {
    bind(el) {
        el.addEventListener("keypress", (e) => {
            if ((e.keyCode < 48 || e.keyCode > 57)) {
                if (e.keyCode != 46) {
                    e.preventDefault();
                } else {
                    if (e.target.value.indexOf('.') >= 0) {
                        e.preventDefault();
                    }
                    console.log(e.target.value);
                }
            }
        });
    }
})

VueGlobal.directive('loader-button', {
    update(el, binding) {
        let childIdx = -1;
        for (let cnt = 0; cnt < el.children.length; cnt++) {
            let elem = el.children[cnt];
            if (elem.classList.contains('dx-loader')) {
                childIdx = cnt;
            }
        }
        if (binding.value) {
            if (childIdx == -1) {
                el.innerHTML += `<div class="dx-loader">
                <span class="loader_btn"></span>
              </div>`;
            }
        } else {
            if (childIdx >= 0) {
                el.children[childIdx].remove();
            }
        }
    }
})

VueGlobal.directive('dxloader',{
    bind(el){
        el.style.position = "fixed";
        el.style.top = 0;
        el.style.left = "100px";
        el.style.width = "100%";
        el.style.height = "100%";
        el.style.minHeight = "500px";
        el.style.display = "flex";
        el.style.background = "#fff";
        el.style.zIndex = "20";
        el.style.perspective = "100px";
        el.style.alignItems = "center";
        el.style.justifyContent = "center";
        el.style.disabled = true;
        el.innerHTML = `<!--<div id="dx-bg" style="position:absolute;height:100%;width:100%;background:#fff;pointer-events: none;                 opacity:0.6;"></div>--><div id="loader-content-dx">
            <?xml version="1.0" encoding="utf-8"?>
            <svg class="loader" style="width: 70px;height: 70px;z-index:9999999" xmlns="http://www.w3.org/2000/svg" version="1.2" baseProfile="tiny" x="0" y="0" viewBox="0 0 200 200" xml:space="preserve"><path style="fill: #04b48d;transform-origin: center;animation: rotate-dx 1.5s linear 0s infinite reverse;" class="loaderreverse" d="M200 100c0-30.3-13.5-57.5-34.8-75.8 -4.8-4.1-12.2-3-15.8 2.3v0c-3 4.5-2.4 10.7 1.8 14.2 16.6 14.4 27.1 35.6 27.1 59.3s-10.5 44.9-27.1 59.3c-4.1 3.6-4.8 9.7-1.8 14.2v0c3.6 5.3 11 6.4 15.8 2.3C186.5 157.5 200 130.3 200 100z"/><path style="fill: #04b48d;transform-origin: center;animation: rotate-dx 1.5s linear 0s infinite;" d="M156.7 100c0-14.9-5.8-28.5-15.2-38.6 -4.6-4.9-12.6-4.1-16.3 1.4l-0.4 0.6c-2.8 4.1-2.2 9.5 1.2 13.2 5.7 6.2 9.1 14.4 9.1 23.5 0 9-3.4 17.3-9.1 23.5 -3.3 3.7-3.9 9-1.2 13.2l0.4 0.6c3.7 5.6 11.7 6.3 16.3 1.4C150.9 128.5 156.7 114.9 156.7 100z"/></svg>
        </div>`
        // document.styleSheets[0].insertRule('\
        // @keyframes rotate-dx {\
        //     from { transform: rotateZ(0deg);   }\
        //     to   { transform: rotateZ(360deg); }\
        // }'
        // );
    },
    update(el,binding){
        if(binding.value){
            el.style.display = "flex";                       
        }else{
            setTimeout(() =>{
                el.style.display = "none";           
            },200);
        }
    }
})

VueGlobal.filter('date', function (value, format = "YYYY-MM-DD HH:mm") {
    if (!value) return '';
    let date = new Date(value);
    if (moment.isDate(date)) {
        let momentInstance = new moment(date);
        return momentInstance.format(format);
    } else {
        return value;
    }
})

VueGlobal.filter('currency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 0,
        maximumSignificantDigits:3
    });
    return formatter.format(value);
});

VueGlobal.filter('relativeTime', function (value) {
    if (!value) return '';
    let date = new Date(value);
    if (moment.isDate(date)) {
        return distanceInWordsToNow(new Date(value), { addSuffix: true });
    } else {
        return value;
    }
})

VueGlobal.filter('number', function (value) {
    if (!value) return '';
    return parseFloat(value);
})